import Pages from "../components/layout/Pages";
import {concepts} from "fearless-common";
import {Button} from "fearless-common-ui";
import {routes} from "../utils";
import photo51logo from "../assets/images/logos/photo51-blue-desktop-icon.svg";
import React, {useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import axios from "axios";
import {trackPurchase} from "../components/tracking/trackEvent";

/**
 * Displays a checkout success page to the user.
 *
 * This method renders a centered success message, including a logo,
 * a thank-you message, a follow-up instruction, and a button for navigation.
 *
 * TODO improve page according to https://stripe.com/en-nl/resources/more/payment-successful-pages
 *
 * @return {JSX.Element} The rendered checkout success page component.
 */
export default function CheckoutSuccessPage() {
  // Retrieve information about the order from the query parameters
  const [sp] = useSearchParams();

  useEffect(
    /**
     * Track a Google Analytics event
     */
    function trackCheckoutSuccess() {
      const sessionId = sp?.get('session_id');
      if (sessionId) {
        const source = axios.CancelToken.source();
        axios.get(`/stripe/sessions/${sessionId}`, { cancelToken: source.token }).then(({ data }) => {
          trackPurchase(sessionId, data.value, data.currency);
        }).catch(() => {
          // Do nothing, the event is not tracked
        });
      }
    }, []);

  return (
    <div className="bg-neutral-100">
      <Pages.Centred width="xs" className="text-center" padded={false} verticalAlignCenter>
        <div className="bg-white border border-neutral-300 p-5" style={{ borderRadius: 10, borderWidth: '0.5px' }}>
          <img src={photo51logo} height={80} alt={`${concepts.Photo51} logo`} />

          <h1 className="my-3 neutral-700">Thanks for your order!</h1>

          <p className="neutral-700">You can now use {concepts.Photo51}.</p>

          <Button href={routes.photo51Cloud} variant="success" size="lg" className="mt-4">
            Open {concepts.Photo51} cloud
          </Button>
        </div>
      </Pages.Centred>
    </div>
  )
}
